<!-- Page Header -->
<app-page-header
  title="Admin Dashboard"
  subtitle="Verwalte Benutzer, Einstellungen und System"
  icon="admin_panel_settings"
  variant="gradient">
</app-page-header>

<!-- Apple-style Content Grid -->
<div class="apple-container apple-slide-up">
  <div class="apple-admin-grid">
    <!-- Pending Customers Card -->
    <div class="admin-grid-item">
      <div class="apple-card ratings-widget-container">
        <div class="ratings-widget-header">
          <mat-icon class="card-icon pending-icon">pending_actions</mat-icon>
          <span class="apple-heading-4">Registrierungen</span>
        </div>
        <div class="ratings-widget-content">
          <p class="card-description">
            Kunden, die über Einladungslinks registriert wurden und auf Freischaltung warten.
          </p>
        </div>
        <div class="ratings-widget-actions">
          <button mat-raised-button routerLink="/admin/pending-customers" color="primary" class="ratings-widget-action-btn">
            <mat-icon>arrow_forward</mat-icon>
            Ansehen
          </button>
        </div>
      </div>
    </div>

    <div class="admin-grid-item">
      <app-ratings-widget></app-ratings-widget>
    </div>
    <div class="admin-grid-item">
      <app-admin-tools></app-admin-tools>
    </div>
  </div>
</div>
